import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/contents/about-us")({
  beforeLoad: () => {
    throw redirect({ to: "/about", replace: true });
  },
});
